module.exports = __webpack_public_path__ + "static/media/sf-onemarket.af6a0fe6.sketch";